<template>
    <div class="wrap">
        <div class="container container_top">
         <div class="pay_state">
            <div class="paid_cg">
                <van-image class="paid_img" src="https://www.xiangzh.com/static/index/default/images/success.png">
                    <template v-slot:loading>
                        <van-loading type="spinner" size="20" />
                    </template>
                </van-image>
                <p>付款成功</p>
                <p>您已成功付款</p>
            </div>
            <div class="paid_info">
                <div class="paid_info_two f-clearfix">付款价格 : <span>${{order_detail.pay_price}}</span>
                </div>
                <div class="paid_info_tree f-clearfix">
                  您可以  <router-link to='/'>查看我的订单 &gt;&gt;</router-link>
                </div>
            </div>
        </div>
        </div>
        <v-foot></v-foot>
    </div>
</template>
<style>
.container_top{margin-top:45px}
</style>
<script>
    // @ is an alias to /src
    export default {
        created() {
            this.order_no = this.$route.query.order_no;
        },
        data() {
            return {
                order_detail: [],
                order_no: 0,
                allmoney:0,
            }
        },
        methods: {
            getData(){
                var url = 'api/order/detail';
                var data = {orderno:this.order_no}
                var _this = this;

                this.POST(url,data,function (ret) {
                    if(ret.code === 0){
                        _this.order_detail = ret.data;
                        if(_this.order_detail.length > 0) {
                            for (var i = 0 ;i<_this.order_detail.length ;i++){
                                window.fbq('trackCustom', 'pay_success_h5', {"allmoney":_this.allmoney,"value":_this.order_detail[i].goods_id,"order_no":_this.order_no});
                                window.gtag('event', 'pay_success_h5', { 'method' : 'pay_success_h5',"value":_this.order_detail[i].goods_id,"order_no":_this.order_no});
                                window.console.log("oo------------oo");
                                window.console.log({"allmoney":_this.allmoney,"value":_this.order_detail[i].goods_id,"order_no":_this.order_no});
                            }
                        }       
                    }
                })
            }
        },
    }
</script>